import Platform from "react-native-web/dist/exports/Platform";
const webStyles = {
  'top-start': {
    top: 0,
    left: 0
  },
  'top-center': {
    top: 0,
    left: '50%',
    transform: [{
      translateX: '-50%'
    }]
  },
  'top-end': {
    top: 0,
    right: 0
  },
  'right-start': {
    top: 0,
    right: 0
  },
  'left-start': {
    top: 0,
    left: 0
  },
  'left-center': {
    top: '50%',
    left: 0,
    transform: [{
      translateY: '-50%'
    }]
  },
  'right-center': {
    top: '50%',
    right: 0,
    transform: [{
      translateY: '-50%'
    }]
  },
  'bottom-start': {
    bottom: 0,
    left: 0
  },
  'left-end': {
    bottom: 0,
    left: 0
  },
  'bottom-center': {
    bottom: 0,
    left: '50%',
    transform: [{
      translateX: '-50%'
    }]
  },
  'bottom-end': {
    bottom: 0,
    right: 0
  },
  'right-end': {
    bottom: 0,
    right: 0
  },
  'top-stretch': {
    top: 0,
    left: 0,
    right: 0,
    width: '100%'
  },
  'left-stretch': {
    top: 0,
    bottom: 0,
    left: 0,
    height: '100%'
  },
  'right-stretch': {
    top: 0,
    bottom: 0,
    right: 0,
    height: '100%'
  },
  'bottom-stretch': {
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%'
  }
};
const webBackgroundPositions = {
  'top-start': 'left top',
  'top-center': 'center top',
  'top-end': 'right top',
  'bottom-start': 'left bottom',
  'bottom-center': 'center bottom',
  'bottom-end': 'right bottom',
  'left-center': 'left center',
  'right-center': 'right center'
};
const nativeStyles = {
  'top-start': {
    top: 0,
    left: 0,
    width: 150,
    height: 200
  },
  'top-center': {
    top: 0,
    left: '50%',
    marginLeft: -75,
    width: 150,
    height: 200
  },
  'top-end': {
    top: 0,
    right: 0,
    width: 150,
    height: 200
  },
  'right-start': {
    top: 0,
    right: 0,
    width: 150,
    height: 200
  },
  'left-start': {
    top: 0,
    left: 0,
    width: 150,
    height: 200
  },
  'left-center': {
    left: 0,
    top: '50%',
    marginTop: -100,
    width: 150,
    height: 200
  },
  'right-center': {
    right: 0,
    top: '50%',
    marginTop: -100,
    width: 150,
    height: 200
  },
  'bottom-start': {
    bottom: 0,
    left: 0,
    width: 150,
    height: 200
  },
  'left-end': {
    bottom: 0,
    left: 0,
    width: 150,
    height: 200
  },
  'bottom-center': {
    bottom: 0,
    left: '50%',
    marginLeft: -75,
    width: 150,
    height: 200
  },
  'bottom-end': {
    bottom: 0,
    right: 0,
    width: 150,
    height: 200
  },
  'right-end': {
    bottom: 0,
    right: 0,
    width: 150,
    height: 200
  },
  'top-stretch': {
    top: 0,
    left: 0,
    right: 0,
    width: '100%'
  },
  'left-stretch': {
    top: 0,
    bottom: 0,
    left: 0,
    height: '100%'
  },
  'right-stretch': {
    top: 0,
    bottom: 0,
    right: 0,
    height: '100%'
  },
  'bottom-stretch': {
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%'
  }
};
export const backgroundPositions = Platform.OS === 'web' ? webBackgroundPositions : {};
export default Platform.OS === 'web' ? webStyles : nativeStyles;